import { scheduleOnce } from '@ember/runloop';
export default function (...args) {
  // @ts-ignore: typing this correctly in a backwards compatible way is too difficult, ignoring
  return scheduleOnce('afterRender', ...args);
}